import { COLOR } from '$gstyles/enums';
import intl from '$gintl';

const dialog = {
  alert: (params) => {
    const button = params.button || {
      text: intl('BUTTON.OK'),
      handler: params.onPress || (() => {}),
    };

    const alert = document.createElement('ion-alert');
    alert.header = intl(params.title, params.key);
    alert.subHeader = intl(params.subtitle, params.key);
    alert.message = params.text || intl(params.message, params.key);
    if (params.cssClass) alert.cssClass = params.cssClass;
    alert.setAttribute('data-testid', params.testId || 'alert-dialog');
    alert.buttons = [button];

    const rootEl = document.getElementById('root-app');
    if (rootEl) {
      rootEl.appendChild(alert);
      setTimeout(() => {
        alert.present();
      }, 30);
      return alert;
    }
  },

  confirm: (params) => {
    const alert = document.createElement('ion-alert');
    alert.header = intl(params.title);
    alert.subHeader = intl(params.subtitle);
    alert.message = params.text || intl(params.message, params.key);
    if (params.cssClass) alert.cssClass = params.cssClass;
    alert.setAttribute('data-testid', params.testId || 'confirm-dialog');
    alert.buttons = params.buttons || [
      {
        text: intl(params.button2) || intl('BUTTON.CANCEL'),
        cssClass: COLOR.SUCCESS,
        handler: params.onPress2 || (() => {}),
      },
      {
        text: intl(params.button) || intl('BUTTON.OK'),
        handler: params.onPress || (() => {}),
      },
    ];

    const rootEl = document.getElementById('root-app');
    if (rootEl) {
      rootEl.appendChild(alert);
      setTimeout(() => {
        alert.present();
      }, 30);
      return alert;
    }
  },

  /**
   * Single free-text input. `onPress` receives the trimmed value, or is not
   * called at all if the user cancels.
   *
   * Titles/messages here are raw strings rather than intl keys, because these
   * dialogs name user-created things (folders) that have no translation.
   */
  prompt: (params) => {
    const alert = document.createElement('ion-alert');
    alert.header = params.title || '';
    if (params.message) alert.message = params.message;
    if (params.cssClass) alert.cssClass = params.cssClass;
    alert.setAttribute('data-testid', params.testId || 'prompt-dialog');
    alert.inputs = [
      {
        name: 'value',
        type: 'text',
        placeholder: params.placeholder || '',
        value: params.defaultValue || '',
      },
    ];
    alert.buttons = [
      { text: intl('BUTTON.CANCEL'), role: 'cancel' },
      {
        text: params.confirmText || intl('BUTTON.OK'),
        handler: (data) => {
          const value = (data?.value || '').trim();
          if (!value) return false;
          if (params.onPress) params.onPress(value);
          return true;
        },
      },
    ];

    const rootEl = document.getElementById('root-app');
    if (rootEl) {
      rootEl.appendChild(alert);
      setTimeout(() => {
        alert.present();
      }, 30);
      return alert;
    }
  },

  /**
   * Pick one option from a list. `options` is [{ value, labelText }].
   * `onPress` receives the chosen value.
   */
  select: (params) => {
    const alert = document.createElement('ion-alert');
    alert.header = params.title || '';
    if (params.message) alert.message = params.message;
    if (params.cssClass) alert.cssClass = params.cssClass;
    alert.setAttribute('data-testid', params.testId || 'select-dialog');
    alert.inputs = (params.options || []).map((o, i) => ({
      name: 'choice',
      type: 'radio',
      label: o.labelText,
      value: o.value,
      checked: params.defaultValue !== undefined ? o.value === params.defaultValue : i === 0,
    }));
    alert.buttons = [
      { text: intl('BUTTON.CANCEL'), role: 'cancel' },
      {
        text: params.confirmText || intl('BUTTON.OK'),
        handler: (value) => {
          if (params.onPress) params.onPress(value);
          return true;
        },
      },
    ];

    const rootEl = document.getElementById('root-app');
    if (rootEl) {
      rootEl.appendChild(alert);
      setTimeout(() => {
        alert.present();
      }, 30);
      return alert;
    }
  },
};

export default dialog;
